import React, { useState } from 'react';
import { MenuItem, Select, InputLabel,FormControl, Button,IconButton  } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import {Alert } from '@material-ui/lab';
import './download.css'




const DownloadFile = ({languages, curLang, vocabularies, regime, onClose}) => {
  
  const [selectedEntityType, setSelectedEntityType] = useState('All');
  const [selectedReportType, setSelectedReportType] = useState('2');
  const [selectedReportModel, setSelectedReportModel] = useState('1');
  const [selectedSortBy, setselectedSortBy] = useState('PRN');
  const [selectedLanguage, setselectedLanguage] = useState('EN');
  const [openError, setOpenError] = useState(false);
  const [loading, setLoading] = useState(false);

  const showLoader = () => {
    setLoading(true);
  };

  const hideLoader = () => {
    setLoading(false);
  }


  const entityTypeOptions = [
    { key: 'All', value: 'All' },
    { key: 'Entity', value: 'Entity' },
    { key: 'Individual', value: 'Individual' },
  ];

  const reportTypeOptions = [
    { key: 'JSON', value: '1' },
    { key: 'XML', value: '2' },
    { key: 'HTML', value: '3' },
  ];

  const reportModelOptions = [
    { key: 'Legacy', value: '1' },
    { key: 'Enhanced', value: '3' },
  ];

  const sortOptions = [
    { key: 'PRN', value: 'PRN' },
    { key: 'Alphabetical', value: 'NAME' },
  ];

  const handleEntityTypeChange = (event) => {
    setSelectedEntityType(event.target.value);
  };

  const handleReportTypeChange = (event) => {
    setSelectedReportType(event.target.value);
  };

  const handleReportModelChange = (event) => {
    setSelectedReportModel(event.target.value);
  };

  const handleSortByChange = (event) => {
    setselectedSortBy(event.target.value);
  };

  const handleLanguageChange = (event) => {
    setselectedLanguage(event.target.value);
  };

  const downloadFileFromApi = async () => {
    try {
      setOpenError(false);
     
      const apiUrl = process.env.REACT_APP_DOWNLOAD_URL;
      if(apiUrl){
        showLoader();
        // Create the download URL with selected options
        const downloadUrl = `${apiUrl}?lang=${selectedLanguage}&regime=${regime}&entryType=${selectedEntityType}&reportFormat=${selectedReportType}&reportModel=${selectedReportModel}&sortField=${selectedSortBy}`;
        const response =  await fetch(downloadUrl);
        if(response.ok) {
          const a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = downloadUrl;
          a.click();
          hideLoader();
          window.URL.revokeObjectURL(downloadUrl);
          a.remove();
        } else {
          hideLoader();
          console.error('Error downloading file:', response.statusText);
          setOpenError(true);

        }
      } else {
        console.error('Invalid Download Api', apiUrl);
        hideLoader();
        setOpenError(true);

      }
    } catch (error) {
      hideLoader();
      console.error('Error downloading file:');
      setOpenError(true);

    }
  };

  const handleClose = () => {
    onClose()
  };

  const handleCloseError = () => {
    setOpenError(false);
  };

  return (
    
    <div className="downloadContainer">
       
       {openError && (
      <Alert
        severity="error"
        onClose={handleCloseError}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={handleCloseError}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
      >
        An error occurred. Please try again.
      </Alert>
      )}
      <div className="form-controls">
        <div className="form-row">
          <FormControl className="form-control">
            <InputLabel>{vocabularies[curLang]['download']['Language']}</InputLabel>
            <Select value={selectedLanguage} onChange={handleLanguageChange}>
              {languages.map((option) => (
                <MenuItem key={option.type} value={option.type}>
                  {option.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl className="form-control">
            <InputLabel>{vocabularies[curLang]['download']['Entity Type']}</InputLabel>
            <Select value={selectedEntityType} onChange={handleEntityTypeChange}>
              {entityTypeOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.key}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div className="form-row">
          <FormControl className="form-control">
            <InputLabel>{vocabularies[curLang]['download']['Report Type']}</InputLabel>
            <Select value={selectedReportType} onChange={handleReportTypeChange}>
              {reportTypeOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.key}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl className="form-control">
            <InputLabel>{vocabularies[curLang]['download']['Report Model']}</InputLabel>
            <Select value={selectedReportModel} onChange={handleReportModelChange}>
              {reportModelOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.key}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        <div className="form-row">
          <FormControl className="form-control">
            <InputLabel>{vocabularies[curLang]['download']['Order By']}</InputLabel>
            <Select value={selectedSortBy} onChange={handleSortByChange}>
              {sortOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.key}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>

      <div className="buttons-container">
        <Button
          className="submit-button"
          variant="contained"
          color="primary"
          onClick={() => downloadFileFromApi(selectedEntityType, selectedReportType, selectedReportModel, selectedSortBy)}
        >
          {vocabularies[curLang]['download']['Download']}
        </Button>
        <Button
          className="close-button"
          variant="contained"
          color="default"
          onClick={handleClose}
        >
          {vocabularies[curLang]['download']['Close']}
        </Button>
      </div>

      {loading && <div className="loader">Loading...</div>}

     
    </div>
    
  );
};

export default DownloadFile;
